import { useIntl } from '@edx/frontend-platform/i18n';
import StaticPageLayout from './StaticPageLayout';
import { getTermsPageContent } from './content';

const TermsPage = () => {
  const intl = useIntl();

  return <StaticPageLayout {...getTermsPageContent(intl)} />;
};

export default TermsPage;
